<template>
    <header class="header">
        <div class="top-nav">
            <div class="logo">
                <img v-if="locale !== 'zh'" src="@/assets/logo.png" alt="Kooyii Logo" />
                <img v-else src="@/assets/jianshu.png" alt="Kooyii Logo" />
            </div>

            <!-- 导航链接：通过动态 class 控制移动端显示隐藏 -->
            <nav class="nav-links" :class="{ 'mobile-open': isMobileMenuOpen }">
                <div class="nav-item-wrapper" v-for="(item, index) in navItems" :key="index">
                    <!-- 主导航链接 -->
                    <router-link :to="item.path" :class="{ 'active-link': activeNavIndex === index }"
                        @click="setActiveNav(index)">
                        {{ t(`nav.${item.key}`) }}
                    </router-link>

                    <!-- PC端全宽下拉巨型菜单 (Mega Menu) -->
                    <div v-if="item.children" class="mega-menu">
                        <div class="mega-menu-container">
                            <!-- 大字号子菜单列表 -->
                            <div class="mega-menu-list">
                                <router-link v-for="(child, cIdx) in item.children" :key="cIdx" :to="child.path"
                                    class="mega-menu-link" @click="setActiveNav(index)">
                                    {{ child.title }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- 右侧操作区：包含语言切换和移动端菜单按钮 -->
            <div class="right-actions">
                <div class="nav-actions">
                    <div class="lang-selector" @click.stop="toggleLangDropdown">
                        <span class="current-lang">
                            <svg t="1785143888093" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="1873" width="20" height="20">
                                <path
                                    d="M848.805886 805.572222c70.998007-81.260745 109.779266-184.217628 109.779266-293.14448 0-119.204939-46.421262-231.277434-130.713041-315.569212C744.876861 113.862257 634.94103 67.61598 517.788843 66.213028c-1.924839-0.599657-10.290367-0.592494-12.227486 0.01535C388.878868 67.945485 279.434224 114.159016 196.73471 196.85853 113.863281 279.730982 67.630307 389.460106 66.095347 506.415818c-0.428765 1.64957-0.436952 8.601912-0.021489 10.226922 1.082658 117.628024 47.364751 228.058113 130.660852 311.354214 84.291778 84.291778 196.36325 130.713041 315.569212 130.713041 119.204939 0 231.277434-46.421262 315.569212-130.713041 6.139837-6.139837 12.054547-12.444427 17.789155-18.871813 0.50756-0.453325 1.001817-0.928139 1.471514-1.440815C847.750857 807.012014 848.295256 806.299793 848.805886 805.572222zM107.447151 532.043499l187.501418 0c1.322112 65.678862 9.253758 127.264499 22.505573 182.112688-61.690014 16.687054-100.819197 38.371936-121.076566 51.906184C144.30971 701.336206 111.676475 620.35687 107.447151 532.043499zM195.881272 259.408121c20.090571 13.556761 59.242266 35.461653 121.340579 52.260248-12.998035 54.127781-20.827351 114.778116-22.243607 179.432649L107.525945 491.101018C112.076588 403.731134 144.437623 323.612399 195.881272 259.408121zM917.081898 491.099994 729.628576 491.099994c-1.415232-64.630996-9.240455-125.260865-22.229281-179.37432 61.95505-16.693194 101.235682-38.444591 121.56673-52.020794C880.270505 323.860039 912.537396 403.866211 917.081898 491.099994zM688.677908 491.099994 532.167319 491.099994 532.167319 335.061149c52.209082-1.094938 97.103572-6.453992 135.272893-14.033621C680.000272 373.163955 687.286212 430.896844 688.677908 491.099994zM532.167319 294.115598 532.167319 109.918435c36.84107 10.398838 72.779583 49.205679 100.926644 110.015649 8.810666 19.035542 16.645099 39.641859 23.464411 61.521169C621.531626 288.227494 580.261687 293.062616 532.167319 294.115598zM491.223814 110.273523l0 183.805236c-47.504944-1.12666-88.378863-6.001691-123.120109-12.802584 6.807033-21.812795 14.623046-42.35976 23.409153-61.344137C419.351903 159.792333 454.809463 121.175827 491.223814 110.273523zM491.223814 335.040682l0 156.059312L335.928912 491.099994c1.391696-60.213383 8.679683-117.955482 21.243837-170.099073C395.008472 328.536548 439.487499 333.887416 491.223814 335.040682zM335.893096 532.043499l155.330718 0 0 158.667719c-51.609425 1.194198-96.019891 6.563486-133.821845 14.103206C344.576873 651.927913 337.193719 593.243349 335.893096 532.043499zM491.223814 731.672118l0 182.909843c-36.415374-10.902304-71.871911-49.51881-99.709933-109.659539-8.679683-18.752086-16.409738-39.034015-23.157419-60.551074C402.9964 737.645157 443.773106 732.820268 491.223814 731.672118zM532.167319 914.937049 532.167319 731.608673c47.904033 1.025353 89.103364 5.862521 124.116809 12.656251-6.755868 21.555945-14.497179 41.87369-23.190165 60.656475C604.946902 865.73137 569.008388 904.538211 532.167319 914.937049zM532.167319 690.660052 532.167319 532.043499l156.546406 0c-1.298576 61.096497-8.66024 119.68487-21.445428 172.502819C629.154233 697.013761 584.319096 691.710988 532.167319 690.660052zM729.659275 532.043499l187.501418 0c-4.221138 88.138386-36.732599 168.973436-88.620363 233.635131-20.469194-13.668301-59.635215-35.298947-121.30374-51.868321C720.43724 659.049101 728.33921 597.585237 729.659275 532.043499zM801.518906 228.742704c-18.329461 11.570523-52.309366 29.355585-104.858186 43.493583-19.295462-63.056128-46.110177-115.004267-78.06189-150.97655C689.00025 140.410913 751.833297 178.097234 801.518906 228.742704zM406.007991 121.259738c-31.905664 35.920094-58.690704 87.768973-77.979002 150.702304-52.40351-14.241352-86.370113-32.099069-104.581893-43.587728C273.076422 177.914062 335.777463 140.364865 406.007991 121.259738zM223.917816 796.963147c18.284435-11.535731 52.098565-29.230742 104.332207-43.335994 19.271926 62.60485 45.976124 114.186645 77.757968 149.968593C335.99952 884.550994 273.472442 847.181899 223.917816 796.963147zM618.59883 903.595746c31.801287-35.803437 58.517765-87.426165 77.792761-150.08218 51.984978 14.023388 85.972047 31.631418 104.533798 43.208081C751.3329 847.061149 688.718841 884.521319 618.59883 903.595746z"
                                    fill="#1a1a1a" p-id="1874"></path>
                            </svg>
                            {{ currentLangName }}
                            <!-- 箭头 SVG 保持不变 -->
                            <svg v-if="!showLangDropdown" t="1785144487239" class="icon" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2837" width="15" height="15">
                                <path
                                    d="M512 704c8.288 0 15.776-3.232 21.456-8.4l0.064 0.08 352-320-0.08-0.08c6.448-5.856 10.56-14.208 10.56-23.6a32 32 0 0 0-32-32c-8.288 0-15.76 3.232-21.456 8.4l-0.08-0.08L512 628.752 181.536 328.32l-0.08 0.08A31.776 31.776 0 0 0 160 320a32 32 0 0 0-32 32c0 9.376 4.112 17.744 10.544 23.6l-0.08 0.08 352 320 0.08-0.08c5.68 5.168 13.168 8.4 21.456 8.4z"
                                    fill="#1a1a1a" p-id="2838"></path>
                            </svg>
                            <svg v-else t="1785144997120" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="1329" width="15" height="15">
                                <path
                                    d="M512 320c-8.288 0-15.776 3.232-21.456 8.4l-0.064-0.08-352 320 0.08 0.08C132.112 654.256 128 662.608 128 672a32 32 0 0 0 32 32c8.288 0 15.76-3.232 21.456-8.4l0.08 0.08L512 395.248 842.464 695.68l0.08-0.08A31.776 31.776 0 0 0 864 704a32 32 0 0 0 32-32c0-9.376-4.112-17.744-10.544-23.6l0.08-0.08-352-320-0.08 0.08c-5.68-5.168-13.168-8.4-21.456-8.4z"
                                    fill="#1a1a1a" p-id="1330"></path>
                            </svg>
                        </span>

                        <transition name="dropdown">
                            <ul v-show="showLangDropdown" class="lang-dropdown">
                                <li v-for="lang in languages" :key="lang.code" @click.stop="selectLanguage(lang)"
                                    :class="{ active: currentLangCode === lang.code }">
                                    {{ lang.nativeName }}
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>

                <!-- 移动端汉堡菜单按钮 -->
                <div class="mobile-menu-btn" @click="toggleMobileMenu">
                    <svg v-if="!isMobileMenuOpen" viewBox="0 0 24 24" width="24" height="24">
                        <path fill="#2a2a2a" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                    </svg>
                    <svg v-else viewBox="0 0 24 24" width="24" height="24">
                        <path fill="#2a2a2a"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                    </svg>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()
const route = useRoute()

// =========================================
// 1. 导航菜单状态管理
// =========================================
const navItems = ref([
    { key: 'home', path: '/' },
    {
        key: 'software',
        path: '/software',
        children: [
            { title: 'Panel', path: '/software/controlPanel' },
            // { title: 'CMS', path: '/software/cms' }
        ]
    },
    { key: 'products', path: '/products' },
    { key: 'solutions', path: '/solutions' },
    { key: 'contact', path: '/contact' }
])

const activeNavIndex = ref(0)
const isMobileMenuOpen = ref(false) // ✨ 新增：移动端菜单开关状态

const setActiveNav = (index) => {
    activeNavIndex.value = index
    isMobileMenuOpen.value = false // 点击链接后自动关闭移动端菜单
}

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
}

watch(
    () => route.path,
    (newPath) => {
        const matchedIndex = navItems.value.findIndex(item => item.path === newPath)
        if (matchedIndex !== -1) {
            activeNavIndex.value = matchedIndex
        }
        isMobileMenuOpen.value = false // 路由变化时自动关闭菜单
    },
    { immediate: true }
)


// =========================================
// 2. 多语言下拉框状态管理 
// =========================================
const showLangDropdown = ref(false)
const currentLangCode = computed(() => locale.value)

const languages = ref([
    { code: 'en', nativeName: 'English' },
    { code: 'fr', nativeName: 'Français' },
    { code: 'ru', nativeName: 'Русский' },
    { code: 'es', nativeName: 'Español' },
    { code: 'it', nativeName: 'Italiano' },
    { code: 'zh', nativeName: '中文' },
    { code: 'pt', nativeName: 'Português' },
    { code: 'pt-br', nativeName: 'Português (Brasil)' }
])

const currentLangName = computed(() => {
    const lang = languages.value.find(l => l.code === currentLangCode.value)
    return lang ? lang.nativeName : 'English'
})

const toggleLangDropdown = () => {
    showLangDropdown.value = !showLangDropdown.value
}

const selectLanguage = (lang) => {
    locale.value = lang.code
    showLangDropdown.value = false
    localStorage.setItem('user-locale', lang.code)
}

const closeDropdown = (e) => {
    if (!e.target.closest('.lang-selector')) {
        showLangDropdown.value = false
    }
}

onMounted(() => {
    const savedLocale = localStorage.getItem('user-locale')
    if (savedLocale) {
        locale.value = savedLocale
    }
    document.addEventListener('click', closeDropdown)
})

onUnmounted(() => {
    document.removeEventListener('click', closeDropdown)
})
</script>

<style lang="css" scoped>
/* =========================================
   基础样式 (PC端)
   ========================================= */
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    /* ✨ 关键1：给定绝对高度 70px */
    z-index: 999;
    background: #ffffff;
    border-bottom: 1px solid #eaeaea;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    /* ✨ 关键2：让内容区撑满这 70px */
    padding: 0 40px;
    /* 去除原本的上下 padding，避免撑破容器 */
    color: #2a2a2a;
}

.logo {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.logo img {
    height: 40px;
    width: 20vw;
    object-fit: contain;
}

/* 导航容器 */
.nav-links {
    display: flex;
    gap: 80px;
    align-items: center;
    height: 100%;
    /* 撑满导航栏 */
    position: relative !important;
    /* ✨ 关键3：加 !important 强制它成为整个下拉菜单的绝对基准（左边界即“首页”） */
}

.nav-links a {
    color: #2a2a2a;
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    position: relative;
    padding-bottom: 6px;
    transition: color 0.3s ease;
}

.nav-links a:hover {
    color: #0987fc;
}

.nav-links a::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: #0987fc;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateX(-50%);
    border-radius: 2px;
}

.nav-links a.active-link::after,
.nav-links a:hover::after {
    width: 100%;
}

.nav-links a.active-link {
    color: #0987fc;
    font-weight: 600;
}


.nav-item-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    position: static !important;
    /* ✨ 关键4：剥夺它的定位权限，确保菜单不会跟着“软件”跑 */
}

.mega-menu {
    position: absolute;
    top: 100%;
    /* ✨ 因为外层设了 100% 高度，这里会精准落在 70px 底部，绝对不会再重叠 */
    left: 0 !important;
    /* ✨ 严格对齐 nav-links 最左侧的“首页” */
    width: 100%;
    /* 让内容横向撑开，避免文字被挤压 */
    padding: 30px 0;

    /* 默认隐藏及动画 */
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    z-index: 998;
}

/* 全宽背景伪元素 (保持不变) */
.mega-menu::before {
    content: "";
    position: absolute;
    top: 0;
    left: -50vw;
    width: 200vw;
    height: 100%;
    background-color: #fafafa;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
    border-top: 1px solid #eaeaea;
    z-index: -1;
}

.mega-menu::after {
    content: "";
    position: absolute;
    bottom: 100%;
    /* 紧紧贴在下拉菜单的正上方 */
    left: -50vw;
    /* 和你之前的灰色背景一样，保持全屏宽度 */
    width: 200vw;
    height: 15px;
    /* 向上延伸 15px 的隐形热区，完全覆盖任何夹缝 */
    background: transparent;
    /* 完全透明，只用来捕获鼠标轨迹 */
    z-index: 10;
}

/* 鼠标悬浮时展示巨型菜单 */
.nav-item-wrapper:hover .mega-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.mega-menu-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* 文字严格左对齐 */
    text-align: left;
}

/* 灰色分类小标题 */
.mega-menu-label {
    font-size: 0.85rem;
    color: #999;
    margin-bottom: 25px;
}

.mega-menu-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 加粗大字号的子链接 */
.mega-menu-link {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    color: #111 !important;
    text-decoration: none;
    transition: color 0.2s ease;
    padding: 0;
}

.mega-menu-link:hover {
    color: #0987fc !important;
}

/* 隐藏子菜单里原本的下划线动画 */
.mega-menu-link::after {
    display: none !important;
}

/* 右侧操作区包裹器 */
.right-actions {
    display: flex;
    align-items: center;
    gap: 20px;
}

/* 移动端菜单按钮，PC端隐藏 */
.mobile-menu-btn {
    display: none;
    cursor: pointer;
}

.lang-selector {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.current-lang {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.95rem;
}

.lang-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 10px;
    z-index: 9999;
    background-color: #ffffff;
    color: #2a2a2a;
    min-width: 150px;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    list-style: none;
    padding: 8px 0;
}

.lang-dropdown li {
    padding: 10px 20px;
    transition: background-color 0.2s;
    white-space: nowrap;
}

.lang-dropdown li:hover {
    background-color: #f5f5f5;
    /* PC端悬浮颜色微调为浅色，配合白底更协调 */
    color: #0987fc;
}

.lang-dropdown li.active {
    color: #0987fc;
    font-weight: bold;
}


/* =========================================
   ✨ 移动端自适应 (Mobile Responsive) ✨
   ========================================= */
@media screen and (max-width: 768px) {

    /* 1. 修复主导航容器：改为绝对定位的垂直下拉框 */
    .nav-links {
        position: absolute !important;
        top: 70px;
        /* 紧贴在 70px 高的 header 下方 */
        left: 0;
        width: 100%;
        height: auto !important;
        /* 覆盖 PC 端的 100% 高度，解决白色背景方块问题 */
        background-color: #ffffff;
        flex-direction: column !important;
        /* 强制垂直排列，解决文字竖排堆叠 */
        gap: 0 !important;
        /* 清除 PC 端 80px 的间距 */
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);

        display: none !important;
        /* 默认隐藏 */
    }

    .mobile-menu-btn {
        display: flex !important;
        align-items: center;
        justify-content: center;
    }

    .top-nav {
        padding: 0 20px !important;
    }

    /* 2. 汉堡菜单展开状态 (配合 Vue 的 :class="{ 'mobile-open': isMobileMenuOpen }") */
    .nav-links.mobile-open {
        display: flex !important;
    }

    /* 3. 导航项包裹器 */
    .nav-item-wrapper {
        width: 100%;
        height: auto !important;
        flex-direction: column;
        align-items: flex-start;
    }

    /* 4. 修复顶级菜单链接（首页、软件等）的排版 */
    .nav-item-wrapper>a {
        width: 100%;
        padding: 18px 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #f0f0f0;
        display: block;
        /* 解决挤压问题，独占一行 */
        text-align: left;
    }

    /* 移动端取消悬浮下划线动画 */
    .nav-item-wrapper>a::after {
        display: none;
    }

    /* 移动端当前选中状态改为左侧高亮 */
    .nav-item-wrapper>a.active-link {
        background-color: #f4f9ff;
        border-left: 4px solid #0987fc;
        padding-left: 16px;
    }

    /* 5. 巨型菜单移动端重置为普通子菜单 */
    .mega-menu {
        position: static !important;
        opacity: 1;
        visibility: visible;
        transform: none;
        padding: 15px 0 15px 40px !important;
        /* 子菜单往右缩进一点，体现层级 */
        width: 100%;
        box-shadow: none;
        border: none;
        background-color: #fafafa;
        /* 子菜单底色稍微区分一下 */
    }

    /* 隐藏全宽伪元素 */
    .mega-menu::before,
    .mega-menu::after {
        display: none !important;
    }

    .mega-menu-label {
        display: none;
    }

    .mega-menu-list {
        gap: 15px;
    }

    .mega-menu-link {
        font-size: 1.1rem !important;
        font-weight: 500 !important;
        color: #555 !important;
        padding: 0 !important;
        border-bottom: none !important;
    }
}
</style>